import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M7.667 16.667h8c.184 0 .333.149.333.333v.667c0 .184-.15.333-.333.333h-8a.333.333 0 0 1-.333-.333V17c0-.184.149-.333.333-.333m11.667 0h1.333v-3c0-.184.15-.334.333-.334h.667c.184 0 .333.15.333.334v3h.334c.184 0 .333.149.333.333v.667c0 .184-.15.333-.334.333h-4.666a.333.333 0 0 1-.334-.333V17c0-.184.15-.333.334-.333H18V15c0-.184.15-.333.334-.333H19c.184 0 .334.149.334.333z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M15.333 13.667v3.666H14v-3.666c0-.184.15-.334.333-.334H15c.184 0 .333.15.333.334m-2.726.629-2.958 3.653-1.037-.84 2.958-3.652a.333.333 0 0 1 .47-.05l.517.42a.333.333 0 0 1 .05.469",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagIrq = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagIrq_default = SvgFlagIrq;

export { FlagIrq_default as default };
